import { EdrIncidentDetailsWebComponent } from './component/EdrIncidentDetailsWebComponent';

export { EdrIncidentDetailsWebComponent };
